import React from 'react';
import { Card, Descriptions, Avatar, Typography, Row, Col, Tag } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, CalendarOutlined, ShopOutlined, CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const MerchantProfile = () => {
  // Get merchant data from localStorage
  const merchant = JSON.parse(localStorage.getItem('merchant_user') || '{}');

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Profil Merchant</Title>

      <Row gutter={[24, 24]}>
        <Col xs={24} md={8}>
          <Card>
            <div style={{ textAlign: 'center' }}>
              <Avatar
                size={120}
                icon={<ShopOutlined />}
                style={{
                  background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
                  marginBottom: '16px'
                }}
              />
              <Title level={3} style={{ marginBottom: '8px' }}>
                {merchant?.company_name || merchant?.business_name || merchant?.full_name || 'Merchant'}
              </Title>
              <Tag
                color={merchant?.kyc_status === 'verified' ? 'success' :
                      merchant?.kyc_status === 'pending' ? 'warning' : 'default'}
                style={{ fontSize: '14px', padding: '4px 12px' }}
              >
                KYC: {merchant?.kyc_status?.toUpperCase() || 'UNVERIFIED'}
              </Tag>
            </div>
          </Card>
        </Col>

        <Col xs={24} md={16}>
          <Card title="Informasi Sistem" style={{ marginBottom: '24px' }}>
            <Descriptions column={1} bordered>
              <Descriptions.Item
                label="Merchant ID"
                labelStyle={{ fontWeight: 'bold', width: '200px' }}
              >
                <Text code>{merchant?.id || '-'}</Text>
              </Descriptions.Item>

              <Descriptions.Item
                label="Terakhir Login"
                labelStyle={{ fontWeight: 'bold', width: '200px' }}
              >
                <span>
                  <CalendarOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                  {new Date().toLocaleString('id-ID', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </span>
              </Descriptions.Item>

              <Descriptions.Item
                label="Status Akun"
                labelStyle={{ fontWeight: 'bold', width: '200px' }}
              >
                <Tag color="success">
                  <CheckCircleOutlined style={{ marginRight: '4px' }} />
                  Aktif
                </Tag>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>

      <Card title="Informasi Detail" style={{ marginBottom: '24px', width: '100%', overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <Descriptions
            column={{ xs: 1, sm: 2, md: 3, lg: 3 }}
            bordered
            layout="horizontal"
            colon={false}
            labelStyle={{
              fontWeight: 'bold',
              width: '180px',
              minWidth: '180px'
            }}
            contentStyle={{
              minWidth: '150px'
            }}
            style={{ minWidth: '600px' }}
          >
            <Descriptions.Item
              label="Nama Bisnis"
            >
              {merchant?.company_name || merchant?.business_name || '-'}
            </Descriptions.Item>

            <Descriptions.Item
              label="Nama Lengkap"
            >
              {merchant?.full_name || '-'}
            </Descriptions.Item>

            <Descriptions.Item
              label="Email"
            >
              <span>
                <MailOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                {merchant?.email || '-'}
              </span>
            </Descriptions.Item>

            <Descriptions.Item
              label="No. Telepon"
            >
              <span>
                <PhoneOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                {merchant?.phone || '-'}
              </span>
            </Descriptions.Item>

            <Descriptions.Item
              label="Username"
            >
              {merchant?.username || '-'}
            </Descriptions.Item>

            <Descriptions.Item
              label="KYC Status"
            >
              <Tag
                color={merchant?.kyc_status === 'verified' ? 'success' :
                      merchant?.kyc_status === 'pending' ? 'warning' : 'default'}
                icon={merchant?.kyc_status === 'pending' ? <ClockCircleOutlined /> : <CheckCircleOutlined />}
              >
                {merchant?.kyc_status?.toUpperCase() || 'UNVERIFIED'}
              </Tag>
            </Descriptions.Item>
          </Descriptions>
        </div>
      </Card>
    </div>
  );
};

export default MerchantProfile;